import { NON_AG_CDL_LABEL } from '@cibo/core'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { useContext } from 'react'
import { useHistogramLegend } from '../../../../hooks'
import { Config } from '../../../../types'
import { LayerContext } from '../LayerContext'

export const CDLLegend = () => {
  const { mapStyle } = useContext(LayerContext)
  const maptilesServiceUrl = Config.get('MAPTILES_SERVICE_URL')

  // Use the 2025 tileset for all cdl for now.
  // This tileset includes a metadata.json prototype used by rasterLegend.
  const rasterLegend = useHistogramLegend({
    tilesetBaseUrl: `${maptilesServiceUrl}pmtiles/ccdmc/usda-cdl/2025/v1/`,
  })

  const rasterAgLegend =
    rasterLegend && rasterLegend.filter(({ label }) => !NON_AG_CDL_LABEL.includes(label))

  if (mapStyle !== 'CDL' || typeof rasterAgLegend === 'undefined') {
    return null
  }

  if (rasterAgLegend.length === 0) {
    return null
  }

  return (
    <Paper sx={{ p: 1 }}>
      <Stack style={{ maxHeight: '100%', overflow: 'hidden' }}>
        {rasterAgLegend?.map(({ mapColor, label }) => (
          <Stack key={label} direction="row" spacing={1}>
            <Box sx={{ width: 16, height: 16, backgroundColor: mapColor }} />
            <Typography variant="body2">{label}</Typography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  )
}
